import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import CompareLeftColumn from "./CompareLeftColumn";

const CompareRowLayout = ({
  compareHelperItems,
  headerText,
  dronersToCompare,
  children,
  rowOne,
  style,
}: {
  compareHelperItems: any;
  headerText: string;
  dronersToCompare: any;
  children: any;
  rowOne?: boolean;
  style?: any;
}) => {
  const router = useRouter();
  return (
    <div className="compare__row" style={{ ...style }}>
      {!rowOne && <h2 className="compare__headerText">{headerText}</h2>}

      <div
        className="compare__row--main"
        style={{
          gridTemplateColumns: `repeat(${Math.min(
            dronersToCompare.length + 1,
            5
          )}, minmax(130px, 1fr))`,
        }}
      >
        {rowOne ? (
          <button
            className="compare__addBox"
            style={{
              display: dronersToCompare.length < 5 ? "flex" : "none",
            }}
            onClick={() => router.push("/droners")}
            disabled={dronersToCompare?.length >= 4 && true}
            children={
              <Image src="/assets/addIcon.png" alt="" width="50" height="50" />
            }
          />
        ) : (
          <CompareLeftColumn
            items={compareHelperItems}
            dronersLength={dronersToCompare.length}
          />
        )}

        {children}
      </div>
    </div>
  );
};

export default CompareRowLayout;
